var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowBackAlt component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowBackAlt extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.20456 7.60601C7.49745 7.31312 7.49745 6.83825 7.20456 6.54535C6.91167 6.25246 6.43679 6.25246 6.1439 6.54535L1.21967 11.4696C0.926777 11.7625 0.926777 12.2374 1.21967 12.5302L6.1439 17.4545C6.43679 17.7474 6.91167 17.7474 7.20456 17.4545C7.49745 17.1616 7.49745 16.6867 7.20456 16.3938L3.56062 12.7499H20.3849C20.7826 12.7499 21.105 12.4141 21.105 11.9999C21.105 11.5857 20.7826 11.2499 20.3849 11.2499H3.5607L7.20456 7.60601Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowBackAlt.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowBackAlt.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowBackAlt.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-back-alt') === undefined) {
    customElements.define('cat-icon-arrow-back-alt', BlocksIconArrowBackAlt);
}
